export const OFFICES = [
  { id: 1, value: 'Москва' },
  { id: 2, value: 'Минск' },
];
